import { render, staticRenderFns } from "./DefaultDashboard.vue?vue&type=template&id=7ddc68fc&scoped=true"
import script from "./DefaultDashboard.vue?vue&type=script&lang=js"
export * from "./DefaultDashboard.vue?vue&type=script&lang=js"
import style0 from "./DefaultDashboard.vue?vue&type=style&index=0&id=7ddc68fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddc68fc",
  null
  
)

export default component.exports